export default "__VITE_ASSET__CRhW8S6D__"